angular
  .module('contrast.factory.events', [])
  .factory('EventsFactory', function ($http, UserService) {
    return {
      getLatestEvents: function (maxResults) {
        return $http.get(UserService.buildAPIUrl('/events'), {
          params: { limit: maxResults }
        })
      }
    }
  })
